import React from 'react';
import { cn } from '@/utils/cn';
import TextSmall from '../../Typography/TextSmall';

function CategoryChip({
  activeSlug,
  name = null,
  slug = null,
  isLastItem = false,
}) {
  if (!name || !slug) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex items-center px-[12px] bg-white border border-himalayan-poppy rounded-[100px] hover:bg-white hover:border-senate h-[32px] lg:h-[32px] hover:cursor-pointer',
        {
          '!border-richcarmine !text-richcarmine': activeSlug === slug,
          'mr-10': isLastItem,
        },
      )}
    >
      <TextSmall
        text={name}
        className={cn(
          'inline-block text-center font-medium leading-16 lg:leading-20 tracking-[0.24px] lg:tracking-[0.32px] whitespace-nowrap',
          {
            '!text-richcarmine': activeSlug === slug,
          },
        )}
      />
    </div>
  );
}

export default CategoryChip;
